import React from "react";
import Drag from "../../../../DocumentTemplate/NewTemplate/FormComponent/Drag";
import closeIcon from "../../../../../assets/icons/close.svg";

// Styles
import "./DraggableColumn.scss";

const DraggableColumn = ({ title, id, handleSelectColumn }) => {
  return (
    <div className="draggable-column">
      <Drag />
      <span className="draggable-column-title">{title}</span>
      <img
        height={18}
        width={18}
        className="close-button"
        src={closeIcon}
        alt="close"
        onClick={() => handleSelectColumn(false, id)}
      />
    </div>
  );
};

export default DraggableColumn;
